import {Component} from 'lowkey-component';

import type {IField} from './BaseFormField';
import {BaseFormField} from './BaseFormField';

export class FormHiddenField extends BaseFormField implements IField {
  private input: Component<HTMLInputElement | HTMLTextAreaElement> | null =
    null;

  didMount() {
    super.didMount();
    this.input = new Component<HTMLInputElement>(this.element?.querySelector('input') as HTMLInputElement);
    this.input.mount();
  }

  public set readonly(val: boolean) {
    this.input?.element?.setAttribute('disabled', val ? 'true' : 'false');
  }

  get value(): string {
    return this.input?.element?.value || '';
  }

  set value(val: string) {
    this.input?.element?.setAttribute('value', val);
  }

  get name() {
    return this.input?.element?.getAttribute('name') || '';
  }
}
